/**
 * [CurveBeamAI] BoneVue rotate workflow preset.
 *
 * Sets hangingProtocol='mpr' to auto-launch into 3-plane MPR view.
 * The BoneVue rotate panel opens on the right side by default.
 */

import { WorkflowPreset } from '../../types';

export const bonevueRotatePreset: WorkflowPreset = {
  id: 'bonevue-rotate',
  label: 'BoneVue Rotate Image',
  toolbar: {
    sectionOverrides: {
      primary: ['Zoom', 'Pan', 'WindowLevel', 'Crosshairs', 'BoneVueRotateTool'],
    },
  },
  panels: {
    leftPanelClosed: false,
    right: ['@curvebeamai/ohif-extension.panelModule.bonevueRotatePanel'],
    rightPanelClosed: false,
  },
  header: {
    showPatientInfo: false,
    showReturnButton: false,
  },
  customizations: {
    'header.hideUndoRedo': true,
  },
  viewportActionMenus: {
    hiddenKeys: ['orientationMenu', 'dataOverlayMenu'],
  },
  hangingProtocol: 'mpr',
  dataFilters: {
    skipSeriesFilter: true,
    resultUidPreFilter: true,
  },
  defaultVoi: { windowWidth: 2500, windowCenter: 480 },
};
